/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BufferDto
 */
export interface BufferDto {
    /**
     * 
     * @type {string}
     * @memberof BufferDto
     */
    type: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BufferDto
     */
    data: Array<number>;
}

export function BufferDtoFromJSON(json: any): BufferDto {
    return BufferDtoFromJSONTyped(json, false);
}

export function BufferDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BufferDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'data': json['data'],
    };
}

export function BufferDtoToJSON(value?: BufferDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'data': value.data,
    };
}

